import { useParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { PageLayout } from '@/components/layout/PageLayout'
import { PageHeader } from '@/components/layout/PageHeader'
import { useGetApiWalletsCompany } from '@/api/generated/company-management-user/company-management-user'
import { WalletBalanceCards } from './components/WalletBalanceCards'
import { WalletTransactionsTable } from './table-components/WalletTransactionsTable'

export default function WalletPage() {
  const { t } = useTranslation('wallet')

  // Wallet id comes from the URL (/wallet/:walletId); fall back to the first
  // company wallet when the route is opened without one (e.g. the sidebar link).
  const { walletId: walletIdFromUrl } = useParams<{ walletId?: string }>()
  const { data: walletsData, isLoading: walletsLoading, isError: walletsError } = useGetApiWalletsCompany()
  const wallets = ((walletsData as any)?.data ?? walletsData ?? []) as { id: string }[]
  const walletId = walletIdFromUrl ?? wallets[0]?.id ?? ''

  return (
    <PageLayout>
      <PageHeader title={t('header.title')} description={t('header.description')}/>

      <WalletBalanceCards
        walletId={walletId}
        walletResolving={walletsLoading}
        walletResolveError={walletsError}
      />

      <WalletTransactionsTable
        walletId={walletId}
        walletResolving={walletsLoading}
        walletResolveError={walletsError}
      />
    </PageLayout>
  )
}
